import { InterpolateService } from './interpolate.service';
import { run } from 'formula';
import { Injectable } from '@angular/core';

const interpolationOptions = { useEmptyValues: true, usePartialPath: false, clearUnresolvedPatterns: true};
@Injectable()
export class FormulaService {

  constructor() {
  }

  /**
   * This function interpolates the forumula with the interpolateObject and then runs the forumla
   * Another scenario where interpolateObject can be formula data which will be used to calculate the formula
   * where formula doesn't have any interpolation string
   * @param {string} formula
   * @param {object} interpolateObject
   * @param {boolean} emitException
   * @returns {any}
   */
  static evaluateFormula(formula: string, interpolateObject: object, emitException: boolean = false, interpolationOptns?: any) {
    /**
     * Temporary Fix for the defect if any form configuration input name as created as nested object string.
     * Formula service is not understanding the string of nested object name as an input name as
     * it treated as nested object and look for the same which returns null value.
     * the permenant/actual fix is required in interpolate.service.ts, as it handles all the strings/object inputs
     * to manipulate to required form.
     * As it required an extensive understanding the whole scenarios can be used currently with this service and
     * required whole scenarios to be tested that can be impacted as part of this service fix.
     */
    if(!interpolationOptns) {
      interpolationOptns = interpolationOptions;
    }

    if (interpolateObject) {
      for (const [key, value] of Object.entries(interpolateObject)) {
        if (key.includes(".")) {
          let keySplit = key.split(".");
          interpolateObject[keySplit[0]] = {...interpolateObject[keySplit[0]], [keySplit[1]]: value || ""};
        }
      }
    }

    let outputValue = null;
    try {
      const interpolatedString = InterpolateService.interpolate(formula, interpolateObject, true,
        interpolationOptns);
      outputValue = run(interpolatedString, (interpolateObject || { }) );
      if (outputValue && !(outputValue instanceof Error)) {
        return outputValue;
      }
    } catch (exception) {
      if (emitException) {
        throw exception;
      }
      return outputValue;
    }
    return outputValue;

  }

}
